import {
	call, delay, put, race, takeEvery,
} from "redux-saga/effects";
import Env from "../../../consts/env";
import {
	ActionsHighlightReview,
	failureHighlightReview, loadGetHighlightReview, loadHighlightReviewSuccess,
} from "./actions";

function* loadDataHighlightReview(params = {}) {

	try {

		yield put(loadGetHighlightReview());

		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/getHighlightReview`;
		const headers = { ...Env.HEADERS, page: params.page };
		const method = "GET";
		const options = { headers, method };

		const { timeout, response } = yield race({
			timeout: delay(Env.REQUEST_TIMEOUT),
			response: call(fetch, endpoint, options),
		});

		if (timeout) {

			yield put(failureHighlightReview(yield "Error Timeout..."));

		} else {

			const dataHighlightReview = yield response.json();

			if (response.status !== 200) {

				yield put(failureHighlightReview(yield response.statusText));

			} else {

				yield put(loadHighlightReviewSuccess(yield dataHighlightReview));

			}

		}

	} catch (err) {

		yield put(failureHighlightReview(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsHighlightReview.GET_HIGHLIGHT_REVIEW, loadDataHighlightReview);

}
